class HotSpot extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      hotSpotBtn: '[js-hot-spot-btn]',
      hotSpotContent: '[js-hot-spot-content]',
      closeBtn: '[js-close-btn]'
    }
  }

  connectedCallback() {
    console.log('conntected')
    this.hotSpotBtn = this.querySelector(this._selectors.hotSpotBtn);
    this.hotSpotContent = this.querySelector(this._selectors.hotSpotContent);
    this.closeBtn = this.querySelector(this._selectors.closeBtn);
    this._setListeners();
  }

  _setListeners() {
    if(this.hotSpotBtn && this.hotSpotContent) {
      this.hotSpotBtn.addEventListener('click', this._toggleHotSpotContent);
      this.closeBtn.addEventListener('click', this._toggleHotSpotContent);
      enquire.register(config.mediaQueries['desktop'],{
        match: function(){
          this.hotSpotBtn.removeEventListener('click', this._toggleHotSpotContent);
          this.addEventListener('mouseenter', this._toggleHotSpotContent);
          this.addEventListener('mouseleave', this._toggleHotSpotContent);
        }.bind(this)
      })
    }
  }
  
  _toggleHotSpotContent = () => {
    this.hotSpotContent.classList.toggle('hidden');
  }
}
customElements.define("s-hotspot", HotSpot);